/* ============================================================================
   mz-dawbu-bridge.js — small site-wide utilities for the tracking/cart stack.
   Dawbu is a Dawn theme, so the Dawn shims the taos bridge carries are NOT
   copied here (global.js already defines them — redefining would crash).
   This file owns exactly two things:
   • mzEmit(): one custom-event helper so every feature announces itself
     (cart:updated, cart:item-added, cart-drawer:open/close, cart-dock:*)
     for apps/scripts/pixels to hook into.
   • Out-of-stock last: pushes sold-out product cards ([data-mz-oos], stamped
     by card-product.liquid) to the end of their grid on every listing.
     Toggle: Theme settings → Cart → "Push sold-out products to the bottom".
   ========================================================================== */

window.mzEmit = function (name, detail) {
  try {
    document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || {} }));
  } catch (e) {}
};

(function () {
  if (window.MZ_OOS_LAST === false) return;

  var CARD_SEL = '.card-wrapper, .tsp-card, .ccg-card, .ff-product-item';

  function cellFor(card) {
    var el = card;
    while (el.parentElement) {
      var p = el.parentElement;
      var cells = 0;
      for (var i = 0; i < p.children.length; i++) {
        var ch = p.children[i];
        if ((ch.matches && ch.matches(CARD_SEL)) || ch.querySelector(CARD_SEL)) cells++;
      }
      if (cells > 1) return { cell: el, grid: p };
      el = p;
    }
    return null;
  }

  function reorder(root) {
    var cards = (root || document).querySelectorAll('[data-mz-oos]');
    if (!cards.length) return;
    var byGrid = new Map();
    cards.forEach(function (card) {
      var loc = cellFor(card);
      if (!loc) return;
      // Don't touch initialized carousels — moving slides breaks Swiper's state.
      if (loc.grid.classList.contains('swiper-wrapper') && loc.grid.closest('.swiper-initialized, .swiper-container-initialized')) return;
      if (!byGrid.has(loc.grid)) byGrid.set(loc.grid, []);
      byGrid.get(loc.grid).push(loc.cell);
    });
    byGrid.forEach(function (cells, grid) {
      /* IDEMPOTENCE IS THE LOOP-BREAKER: appendChild of an already-last node still
         fires childList mutations, which re-triggered the observer -> reorder ->
         mutations, forever (visible as cards flickering). Only touch the DOM when
         the OOS cells are NOT already the trailing run of the grid. */
      var kids = grid.children, n = kids.length, alreadyTail = cells.length <= n;
      for (var i = 0; alreadyTail && i < cells.length; i++) {
        if (kids[n - cells.length + i] !== cells[i]) alreadyTail = false;
      }
      if (alreadyTail) return;
      reordering = true;
      cells.forEach(function (cell) { grid.appendChild(cell); });
      setTimeout(function () { reordering = false; }, 0);
      if (window.mzEmit) mzEmit('catalog:oos-reordered', { count: cells.length });
    });
  }
  var reordering = false;

  // Initial pass: DOM is parsed when deferred scripts run, before theme sliders init.
  reorder();

  // Re-run after AJAX updates (filters, pagination, tab switches) — debounced, and
  // an early no-op on pages with no sold-out cards (body observers are hot paths).
  var t = null;
  var mo = new MutationObserver(function (muts) {
    if (reordering) return;                       // our own moves — not new content
    if (!document.querySelector('[data-mz-oos]')) return;
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes && muts[i].addedNodes.length) {
        clearTimeout(t);
        t = setTimeout(function () { reorder(); }, 150);
        return;
      }
    }
  });
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });
  else document.addEventListener('DOMContentLoaded', function () {
    mo.observe(document.body, { childList: true, subtree: true });
  });
})();
